import { Component, OnInit } from '@angular/core';
import { EncriptacionService } from 'src/app/services/encriptacion.service';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'app-mesa-ayuda',
  templateUrl: './mesa-ayuda.component.html',
  styleUrls: ['./../../../assets/css/styles.css', './mesa-ayuda.component.css']
})
export class MesaAyudaComponent implements OnInit {

  show = false;
  pageInfo: any = {}; 
  questions: any[] = [];

  cards = [
    { img: 'assets/images/icon/doctor-b.svg', text: 'Orientación médica telefónica.' },
    { img: 'assets/images/icon/protection-b.svg', text: 'Gestión de agenda y consultas.' },
    { img: 'assets/images/icon/file-b.svg', text: 'Solución de problemas durante la videoconsulta.' },
    { img: 'assets/images/icon/mobile-phone.svg', text: 'Soporte tecnológico sobre la plataforma.' },
    { img: 'assets/images/icon/doctor-chat-b.svg', text: 'Resolución de dudas sobre servicio.' }
  ];

  currentIndex = 0;

  constructor(
    private generalService: GeneralService
  ) { }

  ngOnInit(): void {
    this.pageInfo = new EncriptacionService().getPageInfo();    
    this.getQuestions();
  }

  chunkArray(array: any[], size: number): any[] {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  }
  muestraTexto() {
    //console.log("cambio de estado");
    this.show = true
  }

  getQuestions() {
    this.generalService.getQuestions()
      .then((result:any) => {
        // console.log(result, 'result-getQuestions');
        this.questions = result;
      })
      .catch(error => {
        //console.log(error, 'error-getQuestions');

      });
  }

}
